<as-split direction="horizontal" [gutterSize]="defaultGutterSize" (dragEnd)="onPaneResize($event)">
	<!-- Left -->
	<as-split-area size="77">
		<div class="filter-section" [ngClass]="{'filter-section-combine': !tableInfo.hidePaging && showTable}">
			<div class="filters-subsection">
				<app-feat-filter-labels-map *ngIf="!hideAttrFilters"></app-feat-filter-labels-map>
				<app-feat-attribute-filter-labels *ngIf="!hideAttrFilters"></app-feat-attribute-filter-labels>
				<app-feat-filter-labels-qacode *ngIf="!hideAttrFilters"></app-feat-filter-labels-qacode>
			</div>
		</div>
		<div [hidden]="isSchemaTab" class="table-map-section" [ngClass]="{'table-map-section-combine': !tableInfo.hidePaging && showTable}">
			<as-split [hidden]="isA3iTab" direction="vertical" [gutterSize]="defaultGutterSize" (dragEnd)="onPaneResize($event, true)">
				<as-split-area style="position:relative;overflow: hidden;" size="{{100 - mapSplitRatio}}" [visible]="showTable" order=1>
					<div *ngIf="selectedLayer" class="table-section">
						<app-common-datagrid
							#dataTable
							[id]="tableId"
							[columns]="columns"
							[rows]="rows"
							[selectedRows]="selectedRows"
							[selectionType]="tableSelectionType"
							[isPaging]="tableInfo.isPaging"
							[hidePaging]="tableInfo.hidePaging"
							[pageSize]="pageSize"
							[totalNum]="tableInfo.totalCounts"
							[sortType]="tableInfo.sortType"
							[sorts]="tableInfo.tableSorts"
							[rowClass]="tableInfo.rowClass"
							[isPagingOnTop]="true"
							[sampleData]="isSample"
							(paging)="tableInfo.onPaging($event)"
							(activate)="tableInfo.onActivate($event)"
							(sort)="tableInfo.onSort($event)"
							(scroll)="tableInfo.onScroll($event)"
							(tableContextmenu)="tableInfo.onContextmenu($event)"
						></app-common-datagrid>
						<!-- (select)="tableInfo.onSelect($event)" -->
					</div>
					<div class="middle-tab-section">
						<app-feat-layer-tabs></app-feat-layer-tabs>
						<div class="empty-tab-item"></div>
					</div>
					<app-feat-map-tools></app-feat-map-tools>
				</as-split-area>
				<as-split-area size="{{mapSplitRatio}}" order=2>

					<as-split direction="horizontal" disabled [gutterSize]="0" unit="pixel" (dragEnd)="onPaneResize($event)">
						<as-split-area>
							<div class="map-sect">
								<app-main-data-map
									(onMapContextmenu)="onMapContextmenu($event)"
								></app-main-data-map>

								<div #BackgroundTooltip [id]="bgTooltipElemId" class="map-tooltip"></div>
								<div class="map-legend" *ngIf="isEdgePoint">
									<div class="legend-group" style="margin-bottom: 10px;">
										<div *ngFor="let legend of stateLegends;let idx = index;" title="{{legend.tooltip}}" class="legend-item">
											<div class="legend-shape">
												<div [className]="legend.className"></div>
											</div>
											<div class="legend-text">{{legend.text}}</div>
										</div>
									</div>
								</div>

								<!-- <div *ngIf="showPrecisionPlacement" #PrecisionPlacement id="precision-placement">
									<div class="placement-close" (click)="togglePrecisionPlacement(false)">
										<i class="glyphicons glyphicons-remove"></i>
									</div>
									<div class="placement-header">Enter Coordinates</div>
									<div class="edit-geom">
										<div class="geom-coord">
											<div>
												<label>x: </label>
												<input name="coord-x" type="number" [disabled]="selectedRecord[toDeleteCol]" [(ngModel)]="selectedCoords.x" (ngModelChange)="onPrecisePlacement()">
											</div>
											<div>
												<label>y: </label>
												<input name="coord-y" type="number" [disabled]="selectedRecord[toDeleteCol]" [(ngModel)]="selectedCoords.y" (ngModelChange)="onPrecisePlacement()">
											</div>
										</div>
										<div class="geom-unit">
											<button class="btn-1" (click)="switchCoordsUnit()">{{selectedCoords.unit}}</button>
										</div>
									</div>
								</div> -->
							</div>
						</as-split-area>
						<as-split-area size="28">
							<app-feat-map-controls></app-feat-map-controls>
						</as-split-area>
					</as-split>

				</as-split-area>
			</as-split>
			<app-feat-a3i *ngIf="isA3iTab"></app-feat-a3i>
		</div>
	</as-split-area>

	<!-- Right -->
	<as-split-area size="23" [visible]="showRightTabs">
		<div class="right-container">
			<app-feature-vertical-tabs #verticalTabs [tabs]="tabs" [disableSwitchingTab]="disableTabSwitching" (changeTab)="onChangeTab($event)"></app-feature-vertical-tabs>
		</div>
	</as-split-area>
</as-split>
<div *ngIf="isSchemaTab" class="floating-page">
	<app-additional-error-my-layers></app-additional-error-my-layers>
</div>


<ng-template #tabTopoCheck>
	<app-edit-topo-error
		[topoCheckResultIntra]="topoCheck"
		(selectTopoError)="onSelectTopoErrorFromCard($event)"
		(resolve)="onResolveTopoErrors($event)"
		(confirmCrevice)="onConfirmCrevice($event)"
		(commit)="onClickCommitResolved($event)"
	></app-edit-topo-error>
</ng-template>
<ng-template #tabDataTable>
	<app-edit-card #EditCard [columns]="columns"
		[disableEditing]="disableCardEdit()"
		[hideAddButton]="disableCardEdit() || !isMapFilterOn"
		[getRecordId]="getRecordId"
		(selectRecord)="onSelectRecordFromCard($event)"
		(clickAdd)="addRecord()"
		(clickCommit)="commit($event)"
		(clickDiscard)="cancel($event)">
	</app-edit-card>
</ng-template>
<ng-template #tabResolutionCenterTable>
	<app-resolution-inspector #resoInspector></app-resolution-inspector>
</ng-template>
<ng-template #tabResolutionCenter_Domain>
	<app-domain-resolution-inspector #resoDomainInspector></app-domain-resolution-inspector>
</ng-template>
<ng-template #tabDataAddrTable>
	<app-edit-card-fishbone #EditCardFishboneAddr [columns]="fishboneColsByModel[modelKey].addrCols" [selectedRecord]="cardSelectedAddr" [editRecordList]="editAddrList"
	[disableEditing]="editModeDisabled"
	[getRecordId]="getRecordId"
	(selectRecord)="onSelectAddrFromCard($event)" 
	(clickCommit)="commit($event)" 
	(clickDiscard)="cancel($event)"> </app-edit-card-fishbone>
</ng-template>
<ng-template #tabDataCenterlineTable>
	<app-edit-card-fishbone #EditCardFishboneCenterline [columns]="fishboneColsByModel[modelKey].centerlineCols" [selectedRecord]="cardSelectedCenterline" [editRecordList]="editCenterlineList" 
	[disableEditing]="editModeDisabled" 
	[getRecordId]="getRecordId" 
	(selectRecord)="onSelectCenterlineFromCard($event)" 
	(clickCommit)="commit($event)" 
	(clickDiscard)="cancel($event)"> </app-edit-card-fishbone>
</ng-template>
<ng-template #tabQcFilter>
	<app-qc-filters-my-layers [showFishboneFilter]="showFishboneLayer"></app-qc-filters-my-layers>
	<!-- <app-qc-filters-interlayers *ngIf="isFishboneOn" (onClickBuildFishbone)="buildFishbone()"></app-qc-filters-interlayers> -->
</ng-template>
<ng-template #tabA3i>
	<app-a3i-tab></app-a3i-tab>
</ng-template>
<ng-template #tabBatch>
	<app-edit-batch [columns]="editBatchColumns"></app-edit-batch>
</ng-template>
<ng-template #tabException>
	<app-qc-exceptions *ngIf="currentCardId&&recordExceptions" [recordExceptions]="recordExceptions" (onDeleted)="onDeleteException()"></app-qc-exceptions>

	<!-- <app-qc-exceptions *ngIf="cardSelectedRecord&&cardSelectedRecord[exceptionColName]" [recordExceptions]="cardSelectedRecord[exceptionColName]" (onDeleted)="onDeleteException()"></app-qc-exceptions> -->
</ng-template>
<ng-template #tabSchemaError>
	<!-- <app-qc-schema-filters></app-qc-schema-filters> -->
</ng-template>
<ng-template #tabRefDocument>
	<app-feat-reference-document-tab></app-feat-reference-document-tab>
</ng-template>

		<!-- <ng-template #additionalErrorMyLayers>
			<app-additional-error-my-layers></app-additional-error-my-layers>
		</ng-template>
		<ng-template #additionalErrorInterlayers></ng-template>
		<ng-template #additionalErrorCollaborative></ng-template> -->

	<ng-template #qcCellTempl let-row="row" let-column="column" let-value="value">
		<div *ngIf="row[qaNotesColName]&&row[qaNotesColName][column.prop]" title="{{row[qaNotesColName][column.prop] ? getCellTooltip(row, column): ''}}" (mouseover)="onMouseoverErrorCell(row, column)" (mouseout)="onMouseoutErrorCell(row, column)">
			<!-- <div>{{value ? value : '&nbsp;'}}</div> -->
			<div [ngClass]="{'grey-cell': row[column.prop] === null}">{{row[column.prop] === null ? "null": value}}</div> 
			<!-- (value && value.toString().trim() ? value : "&nbsp;") -->
		</div>
		<div *ngIf="!row[qaNotesColName]||!row[qaNotesColName][column.prop]" [title]="value || ''">
			<!-- <div>{{value}}</div> -->
			<div [ngClass]="{'grey-cell': row[column.prop] === null}">{{row[column.prop] === null ? "null": value}}</div>
		</div>
	</ng-template>
	<ng-template #schemaTooltipTempl let-row="row" let-value="value">
		<div [title]="row.gss_desc">{{value}}</div>
	</ng-template>
	<ng-template #geomErrorColumnTempl let-row="row" let-column="column" let-value="value">
			<div *ngIf="row[qaNotesGeomColName]&&row[qaNotesGeomColName].length" class="geom-qc-cell" [title]="getCellTooltip(row, column)">
				<i class="glyphicons glyphicons-globe"></i>
			</div>
			<!-- <div *ngIf="row[qaNotesGeomColName].length===1" [title]="getCellTooltip(row, column)" class="geom-qc-cell" (mouseover)="flashErrors(row)" (mouseout)="stopFlashErrors()">
				{{row[qaNotesGeomColName][0].cd}}
			</div>
			<div *ngIf="row[qaNotesGeomColName].length>1" [title]="getCellTooltip(row, column)" class="geom-qc-cell" (mouseover)="flashErrors(row)" (mouseout)="stopFlashErrors()">
				<select name="geom-err-{{rows.indexOf(row)}}" [(ngModel)]="row[qaNotesGeomCurrentColName]" (ngModelChange)="onSelectGeomErr(row)">
					<option *ngFor="let geomErr of row[qaNotesGeomColName]" [ngValue]="geomErr">{{geomErr.cd}}</option>
				</select>
			</div> -->

			<!-- <div *ngIf="row[column.prop].geoms && (!row[column.prop].geoms.length || !row[qaNotesColName][row[column.prop].col])" class="icon-cell" style="text-align:center;">
				<i class="glyphicons glyphicons-ok"></i>
			</div>
			<div *ngIf="row[column.prop].geoms && row[qaNotesColName][row[column.prop].col]" [title]="row[qaNotesColName][row[column.prop].col]?.msg || ''" style="text-align:center;" class="icon-cell" (mouseover)="flashErrors(row)" (mouseout)="stopFlashErrors()">
				<i class="glyphicons glyphicons-remove"></i>
			</div> -->
	</ng-template>
	<ng-template #fishboneColTempl let-row="row" let-column="column">
		<ng-container *ngIf="row[column.prop]">
			<!-- <div *ngIf="modelKey==='L'&&row[column.prop].legacy" title="{{row[column.prop].legacy.note}}">
				{{row[column.prop].legacy.cd}}
			</div>
			<div *ngIf="modelKey==='N'&&row[column.prop].nena" title="{{row[column.prop].nena.note}}">
				{{row[column.prop].nena.cd}}
			</div> -->
			<div class="same-line">
				<div *ngIf="modelKey!=='L'&&row[column.prop].nena" [ngClass]="{'fishbone-errorcode-cell': row[column.prop].nena.cd&&row[column.prop].nena.cd!=='FS1'}" title="{{'NextGen: ' + row[column.prop].nena.note}}">{{row[column.prop].nena.cd}}</div>
				<div *ngIf="modelKey===''"> | </div>
				<div *ngIf="modelKey!=='N'&&row[column.prop].legacy" [ngClass]="{'fishbone-errorcode-cell': row[column.prop].legacy.cd&&row[column.prop].legacy.cd!=='FS1L'}" title="{{'Legacy: ' + row[column.prop].legacy.note}}">{{row[column.prop].legacy.cd}}</div>
			</div>
		</ng-container>
	</ng-template>

	<!-- <ng-template #schemaErrorTempl let-row="row" let-column="column" let-value="value">
		<ng-container *ngIf="row[schemaQcColName]">
			<div *ngIf="row[schemaQcColName] && row[schemaQcColName].length" [title]="row[schemaQcColName].toolTip" style="text-align:center;" class="icon-cell">
				<i class="glyphicons glyphicons-remove"></i>
			</div>
			<div *ngIf="row[schemaQcColName] && !row[schemaQcColName].length" title="No Error" style="text-align:center;" class="icon-cell">
				<i class="glyphicons glyphicons-ok"></i>
			</div>
			IF: error check is not requested, leave the cell empty
			<div *ngIf="!row[schemaQcColName]">
			</div>
		</ng-container>
	</ng-template> -->
	
	<!-- Table Header Template -->
	<ng-template #featTableHeaderTempl let-column="column" let-sort="sortFn" ngx-datatable-header-template>
		<div class="datatable-header-cell-wrapper" [ngClass]="{'col-schema-error': column.info&&column.info.schemaErrors}">
			<span class="column-header" (click)="sort()" appHtmlTooltip [tooltip]="column.info.tooltip">
				<!-- tooltip="{{column.info ? (column.info.tooltip ? column.info.tooltip : '') : ''}}"
				[options]="{auotPlacement: true, contentType: 'template', placement: 'bottom'}"
				-->
				{{column.name}}
			</span>
			<i *ngIf="column.info&&column.info.schemaErrors" class="glyphicons glyphicons-alert" title="{{column.info ? column.info.schemaErrors : ''}}"></i>
		</div>
	</ng-template>
	<ng-template #featTableHeaderIconTempl let-column="column" let-sort="sortFn" ngx-datatable-header-template>
		<span class="datatable-header-cell-wrapper">
			<div class="table-header-icon">
				<!-- <i *ngIf="column.prop===qaNotesGeomColName" class="glyphicons glyphicons-globe"></i> -->
			</div>
		</span>
	</ng-template>


<!-- Context menu -->
<context-menu #MapContextmenu>
	<!-- <ng-template *ngIf="isTopoErrorEditing" contextMenuItem let-item [enabled]="topoCheck.gap||topoCheck.overlap" (execute)="onContextmenuResolveTopoErrors()">Resolve</ng-template> -->

	<!-- <ng-template *ngIf="!isTopoErrorEditing" contextMenuItem let-item [enabled]="checkEnableMapStartEditing" (execute)="onContextmenuEditGeom($event)">
		<div [title]="disableReasonMapEditing">Start Editing</div>
	</ng-template>
	<ng-template contextMenuItem let-item *ngIf="isMapEditing" (execute)="onContextmenuEditGeom($event, true)">Stop Editing</ng-template> -->
	
	<ng-template *ngIf="isTopologyOn" contextMenuItem let-item [enabled]="checkAttachEnabled" (execute)="onContextmenuAttachToEdge($event)">Attach To Edge...</ng-template>
	<ng-template *ngIf="isMapEditing && $any(selectedLayer).category.geomType !== 'POINT'" [enabled]="checkDeleteVertexEnabled" contextMenuItem let-item (execute)="onContextmenuDeleteVertex($event, true)">Delete Vertex</ng-template>
	<ng-template *ngIf="isMapEditing && $any(selectedLayer).category.geomType !== 'POINT'" contextMenuItem let-item (execute)="onContextmenuAddVertex($event, true)">Add Vertex</ng-template>
	<ng-template *ngIf="showPolygonEditContextmenu" contextMenuItem let-item (execute)="onContextmenuPolygonEdit()">{{polygonEditContextmenuText}}</ng-template>
	<ng-template *ngIf="selectedLayer&&selectedLayer.category.code==='EDGPTS'" contextMenuItem [enabled]="true" (execute)="onContextmenuPprecisionPlace($event)">Precision placement</ng-template>
	<ng-template *ngIf="hasRclLabels||hasInteractiveFishbones" contextMenuItem (execute)="onContextmenuClear()">Clear</ng-template>
</context-menu>
<context-menu #tableContextmenu>
	<ng-template contextMenuItem let-item [enabled]="contextmenuExceptionEnable" (execute)="addException($event.item)">Add Exception...</ng-template>
	<ng-template contextMenuItem let-item (execute)="copyNguid($event.item.row)">Copy Nguid</ng-template>
	<ng-template contextMenuItem let-item (execute)="copyGlobalId($event.item.row)">Copy GlobalId</ng-template>
</context-menu>